import { rhsToRgb } from "../Styles/RHStoRGB";

export const groupArrayByNumber = (array, groupSize) => {
  const groupedArray = [];
  for (let i = 0; i < array.length; i += groupSize) {
    groupedArray.push(array.slice(i, i + groupSize));
  }
  // console.log("after grouping array", array);
  return groupedArray;
};

export const findMatchRGB = (RHScolor) => {
  return rhsToRgb.find((x) => {
    // Assuming item["RHS main color flower"] is a string
    const productValue = RHScolor?.toString();

    // Remove leading 0 or letter+0
    const cleanedProductValue = productValue?.replace(/^[a-zA-Z]*0/, "");

    // Compare with x.rhs
    return cleanedProductValue === x.RHS;
  })?.RGB;
};